import {REPORT_NAME, SMALL_MODAL, FULL_MODAL} from '../utils/types'
import FormValidator from '../../../components/form/form-validator.js'
import url from '../../../utils/url.js'
import saveFile from '../../../utils/saveFile'
import permissionMixin from '../../../mixins/permission-mixin.js'

export const baseReportDownloadMixin = {
  mixins: [permissionMixin],
  data () {
    return {
      freezeAllEvents: false,
      fields: {}
    }
  },
  title () {
    return this.currentConfig ? this.currentConfig.title : 'Скачивание отчета'
  },
  created () {
    this.formValidator = new FormValidator()
    this.setDefaultValues()
  },
  computed: {
    REPORT_NAME () {
      return REPORT_NAME
    },
    reportId () {
      return +this.$route.params.reportId
    },
    modalWindowComponent () {
      return this.$route.params.windowType || this.FULL_MODAL
    },
    SMALL_MODAL () {
      return SMALL_MODAL
    },
    FULL_MODAL () {
      return FULL_MODAL
    },
    showedFields () {
      if (this.currentConfig.fields) {
        return this.currentConfig.fields
      }
      return {}
    },
    reportConfigData () {
      return {}
    },
    currentConfig () {
      const conf = this.reportConfigData
      let current = {}
      for (let key in conf) {
        if (conf[key].id === this.reportId) {
          current = conf[key]
        }
      }
      return current
    }
  },
  methods: {
    setDefaultValues () {
      let showedFields = this.showedFields
      for (let key in showedFields) {
        let field = showedFields[key]
        if (field.hasOwnProperty('default')) {
          this.$set(this.fields, field.name, field.default)
        }
      }
    },
    transformFieldsBeforeSend () {
      this.transformed = Object.assign({}, this.fields)
    },
    submitModal () {
      if (!this.userCanCreate) {
        return
      }

      this.transformFieldsBeforeSend()
      let {hasError} = this.formValidator.validate(this)
      if (!hasError) {
        this.freezeAllEvents = true
        this.$bar.start()
        this.$store.dispatch('downloadFile', {
          endpoint: this.buildLink()
        }).then(r => {
          console.log(r)
          let blob = r.request.response
          let fileName = `${new Date()}.xlsx`
          saveFile({blob, fileName, headers: r.headers})
          this.freezeAllEvents = false
          this.$bar.finish()
          // close small modal after download
          if (this.currentConfig.windowType === SMALL_MODAL) {
            // set delay for more user friendly
            setTimeout(() => {
              this.closeModal()
            }, 300)
          }
        }).catch(erResponse => {
          this.freezeAllEvents = false
          this.$bar.finish()

          if (erResponse && +erResponse.status === 422) {
            let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this)
            if (notFoundedErrorFieldsText) {
              this.$e.errorBox(
                'Некорректно заполнены поля',
                {text: notFoundedErrorFieldsText}
              )
            }
          } else {
            this.$e.errorBox(erResponse)
          }
        })
      }
    },
    closeModal () {
      if (this.freezeAllEvents === true) {
        return false
      }

      if (this.$route.query && this.$route.query.prevRoute) {
        let redirectTo = JSON.parse(this.$route.query.prevRoute)
        this.$router.push(redirectTo)
      } else if (this.$route.matched && this.$route.matched[1]) {
        let redirectRoute = url.getRoute(this.$route.matched[1])
        this.$router.push(redirectRoute)
      }
    },
    buildLink () {
      let current = this.currentConfig
      if (current.endpoint) {
        return current.endpoint({
          query: {
            ...this.transformed
          }
        }, current.id)
      }
      return null
    }
  },
  asyncData () {
    return Promise.resolve()
  }
}
